module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./ServiceDetailsView.js"));
	}, "ServiceDetailsView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ServiceDetailsView!./src/pages/Shop/Member/Personal/ServiceCode/ServiceDetails/ServiceDetailsView.js
// module id = 1471
// module chunks = 418